import { SwapPrice } from '@/core/swap';
import { BadRequestError, Provider, Signer, fulfill } from 'nftx.js';

const processTrade = ({
  network,
  provider,
  quote: { type, methodParameters },
  signer,
}: {
  quote: SwapPrice;
  network: number;
  provider: Provider;
  signer: Signer;
}) => {
  if (type === 'none') {
    throw new BadRequestError('No quote type provided');
  }
  return fulfill({
    network,
    provider,
    signer,
    quote: { type, methodParameters },
  });
};

export default processTrade;
